import type { ReviewVerdict } from "./progress";

export type ReviewRole = "reviewer" | "author";
export type GitHubReviewEvent = "APPROVE" | "REQUEST_CHANGES" | "COMMENT";

export interface ReviewAccess {
  role: ReviewRole;
  allowedOutcomes: ReviewVerdict[];
}

const reviewerOutcomes: ReviewVerdict[] = ["approve", "request-changes", "comment", "not-ready"];
const authorOutcomes: ReviewVerdict[] = ["comment", "not-ready"];

export function reviewAccessFor(actorLogin: string, authorLogin: string): ReviewAccess {
  const author = actorLogin.toLocaleLowerCase() === authorLogin.toLocaleLowerCase();
  return {
    role: author ? "author" : "reviewer",
    allowedOutcomes: [...(author ? authorOutcomes : reviewerOutcomes)],
  };
}

export function reviewOutcomeAllowed(access: ReviewAccess, outcome: ReviewVerdict): boolean {
  return access.allowedOutcomes.includes(outcome);
}

export function githubReviewEventFor(outcome: ReviewVerdict, role: ReviewRole): GitHubReviewEvent {
  if (outcome === "approve") return "APPROVE";
  if (outcome === "request-changes" || (outcome === "not-ready" && role === "reviewer")) {
    return "REQUEST_CHANGES";
  }
  return "COMMENT";
}
